import { useEffect, useRef } from 'react';

interface ScriptOptions {
  src: string;
  id?: string;
  async?: boolean;
  defer?: boolean;
  charSet?: string;
}

type Callback = () => void;

const useScript = (
  {
    src,
    id = '',
    async = true,
    defer = false,
    charSet = 'utf-8'
  }: ScriptOptions,
  callback: Callback
) => {
  const bodyRef = useRef(document.body);
  const scriptRef = useRef(document.createElement('script'));
  const scriptExisting = useRef(document.getElementById(id));

  useEffect(() => {
    if (src) {
      if (bodyRef.current.contains(scriptExisting.current)) {
        return callback();
      }

      scriptRef.current.src = src;
      scriptRef.current.id = id;
      scriptRef.current.async = async;
      scriptRef.current.defer = defer;
      scriptRef.current.charset = charSet;

      bodyRef.current.appendChild(scriptRef.current);
    }

    return () => {
      if (bodyRef.current.contains(scriptRef.current)) {
        bodyRef.current.removeChild(scriptRef.current);
      }
    };
  }, [src, id, async, defer, charSet, callback]);
};

export default useScript;
